//npm package
//api
// import {getChildData} from '../../api/api.js'

//action object
// import { setApplicant } from './authActions'

import * as api from '../../api/api.js';
import { receiveChildrenTable } from './children';

//constants
import {
  // GET_ERRORS,
  CHILD_NAME,
  CHILD_SURNAME,
  CHILD_FATHER_NAME,
  CHILD_BITHDAY_DATE,
  CHILD_FAMILY_RELATION,
  CHILD_DOCUMENT_TYPE,
  CHILD_SERIES,
  CHILD_DOCUMENT_NUMBER,
  CHILD_DATE_OF_ISSUE,
  CHILD_ISSUED_BY,
  CHILD_ACT_NUMBER,
  CHILD_GENDER,
  CHILD_ACT_DATE,
  CHILD_CARE_DATE,
  SET_CHILD,
  // REQUEST_CHILD_DATA,
  // SUCCESS_CHILD_DATA,
  CLEAR_CHILD_DATA,
  // SAVE_CHILD_DATA,
  CHANGE_CHILD,
  CHILD_UNZR_NUMBER,
  CHILD_RNOKPP
} from './types';
import { apllicantData } from './applicantAction.js';

export const addChildAction = data => ({
  type: 'TEST_ADD',
  payload: data
});

export const setChild = child => {
  return {
    type: SET_CHILD,
    payload: child
  };
};

export const getChild = id => async dispatch => {
  try {
    const { data } = await api.gerChild(id);
    dispatch(setChild(data));
  } catch (error) {}
};

export const delChildFromTable = id => async(dispatch, getState) => {
  dispatch({ type: 'REQUEST_DEL_CHILD' });
  try {
    await api.deleteChild(id);
    dispatch({ type: 'SUCCESS_DEL_CHILD' });
    dispatch(getChildren(getState().application.id));
  } catch (error) {
    dispatch({ type: 'FAILURE_DEL_CHILD' });
  }
};

const getChildren = id => async dispatch => {
  dispatch({ type: 'REQUEST_GET_CHILD' });
  try {
    const { data } = await api.getChildren(id);
    dispatch(receiveChildrenTable(data));
    dispatch({ type: 'SUCCESS_GET_CHILD' });
  } catch (error) {
    dispatch({ type: 'FAILURE_SAVE_CHILD' });
  }
};

export const saveChild = datum => async(dispatch, getState) => {
  dispatch({ type: 'REQUEST_SAVE_CHILD' });
  try {
    const { data } = await api.saveChild(datum);
    // console.log(data);
    dispatch(getChildren(getState().application.id));
    dispatch(apllicantData(getState().application.id));
    dispatch({ type: 'SUCCESS_SAVE_CHILD' });
    return Promise.resolve('OK');
  } catch (error) {
    dispatch({ type: 'FAILURE_SAVE_CHILD' });
    return Promise.reject('FAILURE');
  }
};

const childActions = [
  {
    name: 'name',
    type: CHILD_NAME
  },
  {
    name: 'surname',
    type: CHILD_SURNAME
  },
  {
    name: 'fathername',
    type: CHILD_FATHER_NAME
  },
  {
    name: 'bithdaydate',
    type: CHILD_BITHDAY_DATE
  },
  {
    name: 'relation_id',
    type: CHILD_FAMILY_RELATION
  },
  {
    name: 'documenttype',
    type: CHILD_DOCUMENT_TYPE
  },
  {
    name: 'series',
    type: CHILD_SERIES
  },
  {
    name: 'documentnumber',
    type: CHILD_DOCUMENT_NUMBER
  },
  {
    name: 'documentdate',
    type: CHILD_DATE_OF_ISSUE
  },
  {
    name: 'issuedby',
    type: CHILD_ISSUED_BY
  },
  {
    name: 'reg_number',
    type: CHILD_ACT_NUMBER
  },
  {
    name: 'gender',
    type: CHILD_GENDER
  },
  {
    name: 'reg_date',
    type: CHILD_ACT_DATE
  },
  {
    name: 'adopted_date',
    type: CHILD_CARE_DATE
  },
  {
    name: 'unzrNumber',
    type: CHILD_UNZR_NUMBER
  },
  {
    name: 'rnokpp',
    type: CHILD_RNOKPP
  }
];

//depend on the name of the field creates actionCreator
export const childAction = (nameField, value) => {
  const action = childActions.find(({ name }) => name === nameField);
  return action
    ? {
        type: action.type,
        payload: value.toUpperCase()
      }
    : null;
};

//submit CHILD

// function requestChildData() {
//   return {
//     type: REQUEST_CHILD_DATA,
//   };
// }

export function clearChildData() {
  return {
    type: CLEAR_CHILD_DATA,
    name: '',
    surname: '',
    fathername: '',
    bithdaydate: '',
    relation_id: '',
    documenttype: '',
    series: '',
    documentnumber: '',
    documentdate: '',
    issuedby: '',
    reg_number: '',
    gender: '',
    reg_date: '',
    adopted_date: '',
    id: 0,
    scanname: '0',
    unzrNumber: '',
    rnokpp: ''
  };
}

const changeChild = child => {
  return {
    type: CHANGE_CHILD,
    data: child
  };
};

export function childChange(data) {
  return function(dispatch) {
    dispatch(changeChild(data));
  };
}
